var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.75 11.387h-9.268C30.226 8.031 27.42 5.378 24 5.378s-6.226 2.653-6.482 6.009H8.25v3h3.591v27.989h24.318V14.387h3.591zM24 8.378c1.763 0 3.212 1.312 3.457 3.009h-6.914C20.788 9.69 22.237 8.378 24 8.378m9.159 30.998H14.841V14.387h18.318z"
  })))));
};
export default SvgDelete;